import React from 'react'
import {Router, Route, Switch} from 'react-router-dom'

import Homepage from '../views/Homepage'

import { history } from '../helpers'


class Routes extends React.Component {
  render() {
    return(
      <Router basename={ '/CHICAGO_TRIBUNE_PAYWALL_BYPASSER' } history={ history }>
        <Switch>
          <Route exact path={ `${process.env.PUBLIC_URL}/` } component={ Homepage } />
        </Switch>
      </Router>
    );
  }
}

export default Routes
